import React, {useState} from 'react';
import SpeechRecognition, {useSpeechRecognition} from 'react-speech-recognition';
const SpeechText = () => {
    const [language, setLanguage] = useState('');
    const {transcript, resetTranscript} = useSpeechRecognition({continuous: true});
    const handleLanguageChange = (event) => {
        const selectedLanguage = event.target.value;
        setLanguage(selectedLanguage);
        // Stop listening to reset the recognition with the new language
        SpeechRecognition.abortListening();
        // Wait a bit to ensure it's stopped before starting again
        setTimeout(() => {
            // Start listening again with the new language setting
            SpeechRecognition.startListening({continuous: true, language: selectedLanguage});
        }, 100);
    };
    const handleClearText = () => {
        resetTranscript('');
    };
    const handleDownload = () => {
        const filename = 'speech.txt';
        const element = document.createElement('a');
        element.setAttribute(
            'href',
            'data:text/plain;charset=utf-8,' + encodeURIComponent(transcript)
        );
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };
    const languages = [
        {
            no: "16",
            name: "English",
            native: "English",
            code: "en",
        },
        {
            no: "59",
            name: "Tamil",
            native: "தமிழ்",
            code: "ta",
        },
        {
            no: "1",
            name: "Afrikaans",
            native: "Afrikaans",
            code: "af",
        },
        {
            no: "2",
            name: "Albanian",
            native: "Shqip",
            code: "sq",
        },
        {
            no: "3",
            name: "Arabic",
            native: "عربي",
            code: "ar",
        },
        {
            no: "4",
            name: "Armenian",
            native: "Հայերէն",
            code: "hy",
        },
        {
            no: "5",
            name: "Azerbaijani",
            native: "آذربایجان دیلی",
            code: "az",
        },
        {
            no: "6",
            name: "Basque",
            native: "Euskara",
            code: "eu",
        },
        {
            no: "7",
            name: "Belarusian",
            native: "Беларуская",
            code: "be",
        },
        {
            no: "8",
            name: "Bulgarian",
            native: "Български",
            code: "bg",
        },
        {
            no: "9",
            name: "Catalan",
            native: "Català",
            code: "ca",
        },
        {
            no: "10",
            name: "Chinese (Simplified)",
            native: "中文简体",
            code: "zh-CN",
        },
        {
            no: "11",
            name: "Chinese (Traditional)",
            native: "中文繁體",
            code: "zh-TW",
        },
        {
            no: "12",
            name: "Croatian",
            native: "Hrvatski",
            code: "hr",
        },
        {
            no: "13",
            name: "Czech",
            native: "Čeština",
            code: "cs",
        },
        {
            no: "14",
            name: "Danish",
            native: "Dansk",
            code: "da",
        },
        {
            no: "15",
            name: "Dutch",
            native: "Nederlands",
            code: "nl",
        },
        {
            no: "17",
            name: "Estonian",
            native: "Eesti keel",
            code: "et",
        },
        {
            no: "18",
            name: "Filipino",
            native: "Filipino",
            code: "tl",
        },
        {
            no: "19",
            name: "Finnish",
            native: "Suomi",
            code: "fi",
        },
        {
            no: "20",
            name: "French",
            native: "Français",
            code: "fr",
        },
        {
            no: "21",
            name: "Galician",
            native: "Galego",
            code: "gl",
        },
        {
            no: "22",
            name: "Georgian",
            native: "ქართული",
            code: "ka",
        },
        {
            no: "23",
            name: "German",
            native: "Deutsch",
            code: "de",
        },
        {
            no: "24",
            name: "Greek",
            native: "Ελληνικά",
            code: "el",
        },
        {
            no: "25",
            name: "Haitian Creole",
            native: "Kreyòl ayisyen",
            code: "ht",
        },
        {
            no: "26",
            name: "Hebrew",
            native: "עברית",
            code: "iw",
        },
        {
            no: "27",
            name: "Hindi",
            native: "हिन्दी",
            code: "hi",
        },
        {
            no: "28",
            name: "Hungarian",
            native: "Magyar",
            code: "hu",
        },
        {
            no: "29",
            name: "Icelandic",
            native: "Íslenska",
            code: "is",
        },
        {
            no: "30",
            name: "Indonesian",
            native: "Bahasa Indonesia",
            code: "id",
        },
        {
            no: "31",
            name: "Irish",
            native: "Gaeilge",
            code: "ga",
        },
        {
            no: "32",
            name: "Italian",
            native: "Italiano",
            code: "it",
        },
        {
            no: "33",
            name: "Japanese",
            native: "日本語",
            code: "ja",
        },
        {
            no: "34",
            name: "Korean",
            native: "한국어",
            code: "ko",
        },
        {
            no: "35",
            name: "Latvian",
            native: "Latviešu",
            code: "lv",
        },
        {
            no: "36",
            name: "Lithuanian",
            native: "Lietuvių kalba",
            code: "lt",
        },
        {
            no: "37",
            name: "Macedonian",
            native: "Македонски",
            code: "mk",
        },
        {
            no: "38",
            name: "Malay",
            native: "Malay",
            code: "ms",
        },
        {
            no: "39",
            name: "Maltese",
            native: "Malti",
            code: "mt",
        },
        {
            no: "40",
            name: "Norwegian",
            native: "Norsk",
            code: "no",
        },
        {
            no: "41",
            name: "Persian",
            native: "فارسی",
            code: "fa",
        },
        {
            no: "42",
            name: "Polish",
            native: "Polski",
            code: "pl",
        },
        {
            no: "43",
            name: "Portuguese",
            native: "Português",
            code: "pt",
        },
        {
            no: "44",
            name: "Romanian",
            native: "Română",
            code: "ro",
        },
        {
            no: "45",
            name: "Russian",
            native: "Русский",
            code: "ru",
        },
        {
            no: "46",
            name: "Serbian",
            native: "Српски",
            code: "sr",
        },
        {
            no: "47",
            name: "Slovak",
            native: "Slovenčina",
            code: "sk",
        },
        {
            no: "48",
            name: "Slovenian",
            native: "Slovensko",
            code: "sl",
        },
        {
            no: "49",
            name: "Spanish",
            native: "Español",
            code: "es",
        },
        {
            no: "50",
            name: "Swahili",
            native: "Kiswahili",
            code: "sw",
        },
        {
            no: "51",
            name: "Swedish",
            native: "Svenska",
            code: "sv",
        },
        {
            no: "52",
            name: "Thai",
            native: "ไทย",
            code: "th",
        },
        {
            no: "53",
            name: "Turkish",
            native: "Türkçe",
            code: "tr",
        },
        {
            no: "54",
            name: "Ukrainian",
            native: "Українська",
            code: "uk",
        },
        {
            no: "55",
            name: "Urdu",
            native: "اردو",
            code: "ur",
        },
        {
            no: "56",
            name: "Vietnamese",
            native: "Tiếng Việt",
            code: "vi",
        },
        {
            no: "57",
            name: "Welsh",
            native: "Cymraeg",
            code: "cy",
        },
        {
            no: "58",
            name: "Yiddish",
            native: "ייִדיש",
            code: "yi",
        },
    ];
    return (
        <section className="container mt-4">

            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa fa-microphone-lines" aria-hidden="true" style={{color: 'red'}}></i>
                Speech Recognition
                <div style={{display: 'flex', marginLeft: '1rem'}}>
                    <button className="btn btn-danger ms-4 mt-4" style={{boxShadow: '#ded5d5 3px 2px 8px 7px'}}
                            onClick={(e) => {
                                e.preventDefault();
                                SpeechRecognition.stopListening();
                            }}>
                        <i className="fa fa-microphone-lines-slash" style={{fontSize: '18px', color: 'white'}}></i>
                    </button>
                    <button className="btn btn-success ms-4 mt-4" style={{boxShadow: '#ded5d5 3px 2px 8px 7px'}}
                            onClick={(e) => {
                                e.preventDefault();
                                SpeechRecognition.startListening({continuous: true});
                            }}>
                        <i className="fa fa-microphone-lines" style={{fontSize: '18px', color: 'white'}}></i>
                    </button>
                </div>
            </h3>
            <div className="row">
                <div className="language">
                    <p>Language</p>
                    <select name="input-language" id="language" onChange={handleLanguageChange}>
                        {languages.map((lang) => (
                            <option key={lang.code} value={lang.code}>
                                {lang.name}
                            </option>
                        ))}
                    </select>
                </div>

                <textArea className="mt-4 mb-4" placeholder="Speech to Text Here..." rows="10"
                          cols="100">{transcript}</textArea>
                <div className="btn-group">
                    <button type="button" className="btn btn-warning ms-4" onClick={handleClearText}>
                        Clear
                    </button>
                    <button type="button" className="btn btn-success ms-4" onClick={handleDownload}
                            disabled={!transcript}>
                        Download
                    </button>
                </div>
            </div>
        </section>
    );
};
export default SpeechText;
